const JWT_SECTIONS = 3;


/**
 * Extranct scope from jwt token
 * @param {String} token
 * @return {Array<String>}
 */
export default function scope(token) {

    if (!token) {
        throw new Error("malformed jwt")
    }

    var sections = token.split(".");
    
    if (sections.length != JWT_SECTIONS) {
        throw new Error("malformed jwt")
    }

    var payload = JSON.parse(Buffer.from(sections[1], "base64").toString());

    var keys = Object.keys(payload);

    if (!keys.includes("scope")) {
        throw new Error("token content doesn't include scope")
    }

    var scopes = payload["scope"];

    if(!Array.isArray(scopes)) {
        throw new Error("jwt scope should be strings array")
    }

    return scopes;
} 